import React from 'react';
import Grid from '@material-ui/core/Grid';
import Statistic from './Statistic';
import makeStyles from '@material-ui/core/styles/makeStyles';
const useStyles = makeStyles(theme => ({
    statContainer: {
        marginLeft: '1em',
        marginRight: '1em'
    }
}));
function TestResults(props) {
    const classes = useStyles();
    return (React.createElement("div", null,
        React.createElement(Grid, { container: true, direction: 'row', justify: 'center' },
            React.createElement(Grid, { item: true, className: classes.statContainer },
                React.createElement(Statistic, { stat: props.wordsPerMinute, label: 'Words per minute' })),
            React.createElement(Grid, { item: true, className: classes.statContainer },
                React.createElement(Statistic, { stat: props.accuracy + '%', label: 'Accuracy' })))));
}
export default TestResults;
//# sourceMappingURL=TestResults.js.map